import { getBreadCrumbList, setTagNavListInLocalstorage, getMenuByRouter, getTagNavListFromLocalstorage, getHomeRoute, routeHasExist } from '@/libs/util'
import routers from '@/router/routers'
import appConfig from '@/config'
export default {
  state: {
    breadCrumbList: [],
    tagNavList: [],
    homeRoute: getHomeRoute(routers),
    local: '',
    module: appConfig.modules.OM // 当前模块，默认是运营模块
  },
  getters: {
    menuList: (state, getters, rootState) => getMenuByRouter(routers, routers),
    tagNavList: state => state.tagNavList,
    module: state => state.module
  },
  actions: {
    setTagNavList ({commit}, list) {
      return commit('setTagNavList', list)
    },
    setModule ({commit}, module) {
      return commit('setModule', module)
    },
    setHomeTagNav ({commit}, route) {
      return commit('setHomeTagNav', route)
    }
  },
  mutations: {
    setModule (state, module) {
      state.module = module
    },
    setBreadCrumb (state, routeMetched) {
      setTimeout(() => {
        state.breadCrumbList = getBreadCrumbList(routeMetched, state.module.meta)
      }, 200)
    },
    /**
     * @description 设置首页标签
     */
    setHomeTagNav (state, route) {
      if (route) {
        state.tagNavList[0] = route
      }
    },
    setTagNavList (state, list) {
      if (list && list.length) {
        // 防止首页被多次添加
        let tmpList = [list[0]]
        list.forEach(item => {
          if (!item.meta || !item.meta.home) {
            tmpList.push(item)
          }
        })
        state.tagNavList = [...tmpList]
        if (appConfig.tagNavList.cache) setTagNavListInLocalstorage([...tmpList])
      } else {
        //
        let list = getTagNavListFromLocalstorage()
        // 只返回第一个首页和其余不是首页的页面 防止出现多次首页的问题
        state.tagNavList = list ? list.filter((item, index) => index === 0 || !item.meta || !item.meta.home) : []
        // console.log(state.tagNavList)
      }
    },
    addTag (state, { route, type = 'unshift' }) {
      if (!routeHasExist(state.tagNavList, route)) {
        if (type === 'push' && !route.meta.home) {
          state.tagNavList.push(route)
        } else {
          if (route.name === 'home') {
            state.tagNavList.unshift(route)
            // state.tagNavList = state.filter((item, index) => index === 0 || !item.meta || !item.meta.home)
          } else state.tagNavList.splice(1, 0, route)
        }
        if (appConfig.tagNavList.cache) setTagNavListInLocalstorage([...state.tagNavList])
      }
    },
    setLocal (state, lang) {
      state.local = lang
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/app.js